export const DEBUG_OPTIONS = [
  {
    key: "replo.debug.reduxLoggingToConsole",
    label: "Redux logging to console",
  },
  {
    key: "replo.debug.usePublisherStagingUrl",
    label: "Use publisher staging URL",
  },
  {
    key: "replo.debug.useShopifyDebugTools",
    label: "Use Shopify debugging tools",
  },
  {
    key: "replo.debug.enablePosthogSessionRecording",
    label: "Enable Posthog session recording",
  },
  {
    key: "replo.debug.copyComponentJsonMinify",
    label: "Copy component JSON as minified",
  },
  {
    key: "replo.debug.jsonActionPlayer",
    label: "JSON Action Player",
  },
  {
    key: "replo.debug.v2debuggers",
    label: "V2 Debuggers",
  },
];
